import React, { Component } from 'react';
import { Modal, Icon, Button,Input, Tree, Tag,Select,TreeSelect,InputNumber, DatePicker,Tooltip } from 'antd';
import { Label, Refer } from '../basic';
import { proxy } from '../../helpers/util';
import * as  eChartProxy from '../echart/eChartProxy';
// import Sortable from 'react-sortablejs';
import uniqueId from 'lodash/uniqueId';
import _ from 'lodash';
let Sortable = null;
if(process.env.__CLIENT__)  Sortable =require('react-sortablejs');
const Search = Input.Search;
const { TreeNode } = Tree;
const Option = Select.Option;
//运算符
class Operator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMore: false,
            // operatordata: [{}]
        }
    }
    render() {
        let newoperatordata = [
          {operator:"+"},
          {operator:"-"},
          {operator:"*"},
          {operator:"/"},
          {operator:"("},
          {operator:")"}
        ]
        const items = [];
        newoperatordata.forEach((item,index)=>{
          let tags = <Tag key={index} value={item.operator} onClick={() => this.props.onClick(item.operator)}>{item.operator}</Tag>
          items.push(tags)
        })
        return (
            <div>{items}</div>
        );
    }
}
//公式左边
class LeftContent extends Component{
    constructor(props){
        super(props);
        this.state = {
            // formulaData: this.props.formulaData,
            expandedKeys: [],
            searchValue: '',
            autoExpandParent: true,
            selectedKeys: [],
            selectName: '',
            // billNo: billNo,
            billNodata: [],
            entitydata: [],
            isClear: false,
            selecData: []
        }
    }
     //搜索树节点
   getParentKey = (formulaData,value,selecData) => {
    let self = this;
    formulaData.forEach(function(ele){
     if(ele.caption.indexOf(value) > -1){
       if( ele.children){
         selecData.push(ele)
         self.getParentKey(ele.children,value,selecData);
       }
       else{
        selecData.push(ele)
       }
     }
     else if(ele.children && ele.children.length > 0){
      self.getParentKey(ele.children,value,selecData);
     }
   })
  };
  //清空搜索框
 emitEmpty=()=>{
    let {isClear}=this.state;
    let value  = '';
    isClear  = value?true:false;
    this.setState({
      isClear,
      searchValue:value,
      expandedKeys:[],
      autoExpandParent:false,
      selecData:[]
    })
  }
   //搜索选择
   searchSelect(value, option) {
    let {searchValue} = this.state;
    let formulaData  = this.props.formulaData;
    let expandedKeys  = [];
    searchValue =  option.props.children
    let _index = null
    this.loopSelect(formulaData,value,expandedKeys,_index)
    this.setState({
      expandedKeys:expandedKeys,
      searchValue,
      autoExpandParent: true
    })
  }
  loopSelect(formulaData,value,expandedKeys,index){
    let self = this;
    let newindex = index;
    let NewformulaData = formulaData;
    let selectdata = [];
    if(index != null){
      selectdata = formulaData[index]
      NewformulaData = formulaData[index].children ?formulaData[index].children:[].push(formulaData[index]);
    }
    NewformulaData.forEach(function(ele,index){
      if(ele.fieldname  == value){
        if( ele.children){
          expandedKeys.push(selectdata.fieldname)
          self.loopSelect(NewformulaData,value,expandedKeys,index);
        }
        if(!ele.children && !ele.isExpand){
          expandedKeys.push(ele.fieldname)
        }
        if(!ele.children && ele.isExpand){
          expandedKeys.push(selectdata.fieldname)
        }
      }
      else if(ele.children && ele.children.length > 0){
        self.loopSelect(NewformulaData,value,expandedKeys,index);
      }
    })
  }
  //搜索框搜索
  onSearch(value) {
    let {isClear} = this.state;
    let  formulaData = this.props.formulaData;
    let expandedKeys = [];
    let selecData = [];
    if(value !="" && formulaData && formulaData.length > 0){
      this.getParentKey(formulaData,value,selecData);
    }
    if(value === ""){
      selecData = [];
      expandedKeys = [];
    }
    isClear = value ? true: false;
    this.setState({
      searchValue: value,
      isClear,
      selecData,
      expandedKeys
    });
  }
       //搜索框搜索
  onChange = (e, treeNode) => {
    let { isClear} = this.state;
    let formulaData = this.props.formulaData;
    const value = e.target.value;
    let expandedKeys = [];
    if(value !="" && formulaData && formulaData.length > 0){
      this.getParentKey(formulaData,value,expandedKeys);
    }
    isClear = value ? true: false;
    this.setState({
      expandedKeys,
      searchValue: value,
      isClear,
      autoExpandParent: true
    });
  }
    //树节点选择
    onTreeselect(selectedKeys, e) {
        if (!selectedKeys.length) {
          selectedKeys = this.state.selectedKeys
        }
        let selectionStart = this.props.selectionStart;
        let conditionDesc = '',selected=[],selectedKeyTitle =  [];
        let copyedit = this.props.copyString && this.props.copyString.fieldname || ""
        let caption = this.props.copyString && this.props.copyString.caption
         selected =  this.props.formulaData.filter(v=>selectedKeys.includes(v.fieldname));
         let copySelected = _.cloneDeep(selected)
         let expression = ""
        //  copyedit = `[${selected[0].fieldname}]`
         if(selected && selected.length > 0){
            expression = selected[0].columnDefine && JSON.parse(selected[0].columnDefine).expression
           let copyIndex = expression&&expression.indexOf(`[${copyedit}]`) > -1 ? true:false
           if( copyIndex && selected[0].groupType == 4 && copyedit){
            cb.utils.alert(caption+"已被此公式引用，不可循环引用")
           }
          else{
            copySelected[0].key = selectionStart;
          copySelected[0].fieldname = `[${copySelected[0].fieldname}]`
            // let copy = [{fieldname:`[${selected[0].fieldname}]`,caption:selected[0].caption,key:selected[0].key}]
           selectedKeyTitle = this.props.operatorValue.concat(copySelected)
           selectionStart = selectionStart + 1
        this.setState({ selectName: e.selectedNodes, selectedKeys })
        this.props.onSelect(selectedKeyTitle, selectionStart)
          }
         }
      }
        //渲染搜索值
  getSearchOptions() {
    let {searchValue,selecData} = this.state;
    if (searchValue == '') return
    let options = [];
    if(!selecData.length) {options.push(<Option key={'nodata'} className="haveNodata" disabled>{"暂无搜索结果～"}</Option>)};
    selecData.forEach(function (ele) {
      options.push(<Option key={ele.fieldname} className={ele.isCheck?"selected":"haveNoselect"}>{ele.caption}</Option>)
    }, this);
    return options;
  }
    render(){
        const { searchValue, expandedKeys, autoExpandParent,isClear} = this.state;
        let formulaData = this.props.formulaData;
        const loop = data => data.map((item) => {
            const { fieldname, isExpand, children, } = item;
            const index = (item.caption || item.showCaption).indexOf(searchValue);
            // const beforeStr = (item.caption || item.showCaption).substr(0, index);
            // const afterStr = (item.caption || item.showCaption).substr(index + searchValue.length);
            const title = (index > -1) && searchValue ? (
              <span>
                {/* {beforeStr} */}
                <span style={{ color: '#f50' }}>{item.caption}</span>
                {/* {afterStr} */}
              </span>
            ) : <span>{item.caption}</span>;
            if (isExpand) {
              return (
                <TreeNode key={fieldname} title={title}>
                  {loop((children || []))}
                </TreeNode>
              );
            }
            return <TreeNode key={fieldname} title={title} isLeaf />;
          });
          let loopData = formulaData.length > 0 ?loop(formulaData):null;
          let clearValue = isClear?<Icon type="close-circle" onClick={()=>this.emitEmpty()} />:null;
          let options = this.getSearchOptions();
        return(
             <div className="defind_all">
        <Button icon="search" className="defind_icon"/>
          <Select placeholder={this.state.placeholder} mode="combobox" value={this.state.searchValue}
          className="defind_select"
            onSelect={(value, option) => this.searchSelect(value, option)} onSearch={(value) => this.onSearch(value)}
            defaultActiveFirstOption={false} showArrow={false} filterOption={false} onChange={this.handleChange} dropdownMatchSelectWidth={false}>
            {options}
          </Select>
        {clearValue}
        <Tree
          selectedKeys={this.state.selectedKeys}
          onSelect={(selectedKeys, e) => this.onTreeselect(selectedKeys, e)}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
        >
          {loopData}
        </Tree>
      </div>)
    }
}
export default class Newformula extends Component{
    constructor(props){
        super(props);
        let start = 0,forValue = [],copyformulaData = [],numPoint = 2;
        let columnDefine = this.props.editData.columnDefine? JSON.parse(this.props.editData.columnDefine):[];
        if(columnDefine && columnDefine.formulaData){
          [ ...forValue] = columnDefine.formulaData;
          start = columnDefine.formulaData.length;
        }
        if(columnDefine && (columnDefine.numPoint==0 || columnDefine.numPoint > 0)){
          numPoint= columnDefine.numPoint
        }
        let key = Object.keys(this.props.editData);
        // this.props.formulaData = _.cloneDeep(this.props.sumConfig.items)
        let copysum = this.props.sumConfig.items.filter(v=>v.selected == 1)
        copyformulaData = _.cloneDeep(copysum)
        let _index = _.findIndex(copysum,(obj)=>{
          return obj.fieldname == this.props.editData.fieldname
        })
        if(_index > -1){
          copysum.splice(_index,1)
        }
        this.state={
            billno: this.props.sumConfig.billnum,
            visible:true,
            errorInfo: '',
            filterName: key.length > 0 && this.props.editData.caption || '',
            operatorValue:forValue,
            selectionStart: start,
            checkState: key.length > 0 ?true:false,
            checkPass: false,
            contextErrInfo: null,
            numPointErrInfo:null,
            nameErrInfo: null,
            checkvalue:'',
            numValue:null,
            isMouseName:'',
            fixNumValue:true,
            isMouseKey:null,
            backNum:{},
            formulaIndex:_index,
            copyformulaData:copyformulaData,
            copysum:copysum,
            numPoint:numPoint
            // copyString:this.props.editData&&this.props.editData.filterName || ""
        }
    };
    onclose=()=>{
       this.props.closeAdd()
       this.setState({visible:!this.state.visible,nameErrInfo: null, enuErrInfo: null, contextErrInfo: null, checkPass: false, numPointErrInfo:null})
    }
    //获取左边选中的选项
    onSelect(conditionDesc, selectionStart) {
        let self = this;
        let checkState = conditionDesc.length ? true : false;
        self.setState({ operatorValue: conditionDesc, selectionStart, checkState, checkPass:false })
    }
    getControl(control, caption, required) {
        const title = required ? <label><Icon type='star' />{caption}</label> : <label>{caption}</label>;
        return (
            <Label control={control} title={title} className="rightcontent_item" />
        );
    }
    //公式名称
    onNameChange(e) {
        this.setState({ filterName: e.target.value })
    }
    //运算符判断
    handleOperatorSelect(e) {
        let { operatorValue, selectionStart } = this.state;
        let  mark  = {caption:e,key:selectionStart,fieldname:e,ID:'mark_formula'};
        operatorValue.push(mark);
        selectionStart = selectionStart +1;
        let checkState = operatorValue.length ? true : false;
        this.setState({ operatorValue, selectionStart, checkState, checkPass:false})
    }
    //校验
    handcheck = () => {
      let expression = '';
        let {billno,operatorValue} = this.state;
        if(operatorValue && operatorValue.length > 0){
          operatorValue.forEach((ele)=>{
            expression = expression+ele.fieldname
          })
        }
        this.sethandcheck(expression, billno)
    }
    async sethandcheck(expression, billNo) {
        const config = {
            url: 'report/checkExpression',
            method: 'POST',
            params: {
                billno: billNo,
                expression: expression
            }
        };
        const json = await proxy(config);
        if (json.code !== 200) {
            this.setState({ errorInfo: json.message, contextErrInfo: null, checkPass: false })
        }
        else {
            cb.utils.alert('校验成功', 'success');
            this.setState({ errorInfo: '', contextErrInfo: null, checkPass: true,checkvalue:json.data })
        }
    }
    //保存公式
    handlesave=()=>{
    let self = this;
    let {operatorValue,filterName,copyformulaData,formulaIndex,numPoint} = self.state;
    let sumConfig = self.props.sumConfig;
    let editData = this.props.editData;
    let formulaData = this.props.formulaData;
    let params = {},items=[],item = {},expression="",newData = [];
    params.billnum = self.state.billno;
    params.id = sumConfig.id;
    params.name = sumConfig.name;
    params.isOnlyTotal = true;
    let caption  = filterName;
   operatorValue.forEach((ele)=>{
    //  ele.fieldname = ele.fieldname.replace(/\[\]/g,'')
    expression = expression + ele.fieldname;
    let newTarget = {
      caption:ele.caption,
      fieldname:ele.fieldname,
      key:ele.key
    }
    newData.push(newTarget)
   })
   let formula = {
     expression:expression,
     formulaData:newData,
     numPoint:numPoint
    }
   item = {
     showCaption:caption,
     columnDefine:JSON.stringify(formula),
     groupType: 4,
     value:'',
   };
   if(formulaIndex > -1){
    params.items =  copyformulaData;
    params.items.splice(formulaIndex,1,item)
   }
   else{
     let items = [];
     items.push(item)
    params.items = copyformulaData.concat(items)

   }
    let callback = (json) => {
      if (json.code === 200) {
        self.onclose();
        self.props.model.execute('saveSumArea')
      }
      if (json.code !== 200) {
        cb.utils.alert("保存失败","error")
      }
    }
    eChartProxy.doProxy(eChartProxy.url.saveTotalSchema, 'POST', params, callback);
    }
    //判断名称是否为空
    changeNameErrInfo = (text) => {
        this.setState({ nameErrInfo: text })
    }
    //判断公式表达式是否为空
    changeContextErrInfo = (text) => {
        this.setState({ contextErrInfo: text })
    }
    //精度值不能为空
    onNumPointErrInfoChange=(text)=>{
      this.setState({ numPointErrInfo: text })
    }
    onDelete=(data,tag)=>{
      let {operatorValue}=this.state;
      let _index = _.findIndex(operatorValue, (obj,index) => {
        return index == tag && obj.fieldname === data.fieldname
        })
        if(_index > -1){
          operatorValue.splice(_index,1);
        }
        this.setState({operatorValue})
    }
    //数值选择
    numChange=(e)=>{
      let selectNum = e.target.value;
     if(selectNum){
      this.setState({numValue:selectNum,fixNumValue:false});
     }
     else{
       this.setState({numValue:'',fixNumValue:true})
     }
    }
    //精确度
    numPointChange=(e)=>{
      let numpoint = e;
      if(numpoint > 6 || numpoint < 0){
        this.onNumPointErrInfoChange("精度值不能小于0大于6")
      }
      else{
        this.onNumPointErrInfoChange('')
        this.setState({numPoint:numpoint})
      }
    }
    //确定插入数字
    fixNum(){
      let {operatorValue,numValue,selectionStart,backNum} = this.state;
      if(numValue){
      let numarry = {caption:numValue,key:selectionStart,fieldname:numValue,numTag:"number"};
      if(JSON.stringify(backNum) !="{}"){
        operatorValue.forEach((obj,index)=>{
          if(obj.caption == backNum.caption){
            obj.caption = numValue;
            obj.fieldname = numValue
          }
        })
      }
      else{
        operatorValue.push(numarry);
      }
      selectionStart = selectionStart + 1;
      this.setState({operatorValue,fixNumValue:true,numValue:'',selectionStart,backNum:{}})
      }
      else{
        cb.utils.alert("请输入数字");
        this.setState({fixNumValue:true})
      }
    }
    //插入公式中的数字回填到输入框
    backfill=(ele)=>{
      this.setState({numValue:ele.caption,backNum:ele,fixNumValue:true})
    }
    //拖拽排序
    dragOrder(items) {
      let { operatorValue} = this.state;
      let afterDragItems = [],copyDrag = [];
      items.forEach(function (ele) {
        operatorValue.forEach(function (val,index) {
          if (index == ele) {
            afterDragItems.push(val)
          }
        })
      })
      this.setState({ operatorValue: afterDragItems})
    }
    getFilterControl() {
        const classname = 'error_info';
        let selectValue  = [] ;
        let self = this;
        let { filterName, errorInfo, operatorValue,numValue,fixNumValue,numPoint} = self.state;
        if(operatorValue && operatorValue.length > 0){
          operatorValue.forEach((ele,index)=>{
            if(ele.ID){
              let obj = <Button id={ele.ID} key={uniqueId()} data-id={index}
            >
            {ele.caption}
            <Icon type="close-circle" onClick={()=>self.onDelete(ele,index)}/>
            </Button>
            selectValue.push(obj)
            }
            else{
              if(ele.numTag == "number"){
                let obj = <Button id="drag_formula" key={uniqueId()} data-id={index}
                onClick={()=>self.backfill(ele)}
                >
                {ele.caption}
                <Icon type="close-circle" onClick={()=>self.onDelete(ele,index)}/>
                </Button>
                selectValue.push(obj)
              }
              else{
                let obj = <Button id="drag_formula" key={uniqueId()} data-id={index}
              >
              {ele.caption}
              <Icon type="close-circle" onClick={()=>self.onDelete(ele,index)}/>
              </Button>
              selectValue.push(obj)
              }
            }
          })
        }
        const addDefinedName = <Input className={this.state.nameErrInfo ? classname : null} value={filterName} placeholder="请输入" onChange={(e) => this.onNameChange(e)} />
        const numInput = <div><Input value={numValue} placeholder="输入数字后，点击后方的按钮插入数字" onChange={(e)=>this.numChange(e)}/><Icon type="huichequeren" className={fixNumValue?"clearNum":"enterNum"} onClick={()=>this.fixNum()}></Icon></div>
        const pointNum = < InputNumber onChange={(e)=>this.numPointChange(e)} min={0} max={6} defaultValue={numPoint}></InputNumber>
        const operatorCom = <Operator onClick={(e) => this.handleOperatorSelect(e)} />
        const addDefinedCondition = <div className="formula_drag" rows={3} >
          <Sortable
          tag = "div"
          options={{
            group:{
              name:'shared',
              pull:false,
              put:false
            },
            axis :"xy"
          }}
          onChange={(items)=>{
            this.dragOrder(items)
          }}
          >
             {selectValue}
          </Sortable>
          </div>
        return (
            <div>
                <div className="add_defined">
                    {this.getControl(addDefinedName, '公式名称', true)}
                    {this.state.nameErrInfo ? <div className='error'>{this.state.nameErrInfo}</div> : null}
                </div>
                <div className="operatorCom">{this.getControl(operatorCom, '运算符')}</div>
                <div className="add_defined add_number">
                  {this.getControl(numInput,'数字')}
                </div>
                <div className='add_defined add_expression'>
                    {this.getControl(addDefinedCondition, '表达式', true)}
                    {errorInfo ? <label className="error">{errorInfo}</label> : null}
                    {this.state.contextErrInfo ? <div className='error'>{this.state.contextErrInfo}</div> : null}
                </div>
                <div className='add_defined add_numpoint'>
                {this.getControl(pointNum,'精度值',true)}
                {this.state.numPointErrInfo ? <div className='error'>{this.state.numPointErrInfo}</div> : null}
                </div>
            </div>
        )
    }
    render(){
      let isedit = JSON.stringify(this.props.editData) != "{}" ? true:false;
      let checkFormula = '',{operatorValue,checkPass,filterName,checkState,numPoint} = this.state;
      if(operatorValue && operatorValue.length > 0){
        operatorValue.forEach((ele)=>{
          checkFormula = checkFormula + ele.fieldname
        })
      }
        return(
            <div className="adddefined_modal">
                <Modal title={isedit ? "编辑公式" : "新增公式"} visible={this.state.visible} className="addfilter_content" width={820}
                    onCancel={() => this.onclose()} maskClosable={false}
                    footer={<Filterfooter
                        onsave={this.handlesave}
                        handleclose={() => this.onclose()}
                        checkPass={checkPass}
                        filterName={filterName}
                        numPoint = {numPoint}
                        operatorValue={checkFormula}
                        checkitem={this.handcheck}
                        checkState={checkState}
                        onNameErrInfoChange={this.changeNameErrInfo}
                        onContextErrInfoChange={this.changeContextErrInfo}
                        onNumPointErrInfoChange={this.onNumPointErrInfoChange}

/>}>
                    <div style={{ height: 480 }}>
                        <div className="LeftContent" style={{ width: 232, float: 'left', height: 494, overflowy: 'auto', marginRight: 26 }}>
                            <LeftContent onSelect={(conditionDesc, selectionStart) => this.onSelect(conditionDesc, selectionStart)} model={this.props.model} selectionStart={this.state.selectionStart} operatorValue={this.state.operatorValue} formulaData={this.state.copysum} copyString = {this.props.editData} />
                        </div>
                        <div className="RightContent" style={{ width: 514, float: ' left', marginleft: 34, paddingtop: 20, height: 494, overflowy: 'auto' }}>
                            {this.getFilterControl()}
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}
class Filterfooter extends Component {
    handleCancel = () => {
        this.props.onNameErrInfoChange('');
        this.props.onContextErrInfoChange('');
        this.props.onNumPointErrInfoChange('');
        this.props.handleclose();
        return
    }
    handleCheck = () => {
        this.props.checkitem();
    }
    handleOk = () => {
        this.props.onNameErrInfoChange('')
        this.props.onContextErrInfoChange('')
        this.props.onNumPointErrInfoChange('')
        const { operatorValue, filterName,numPoint } = this.props
        if (filterName == '' || operatorValue == '' || numPoint == "" || numPoint == undefined) {
            if (filterName == '' || filterName == undefined) {
                this.props.onNameErrInfoChange('不能为空')
            }
            if (operatorValue == '' || operatorValue == undefined) {
                this.props.onContextErrInfoChange('不能为空')
            }
            if(numPoint == "" || numPoint == undefined){
              this.props.onNumPointErrInfoChange('不能为空')
            }
            return
        }
        this.props.onsave();
    }
    render() {
        const checkPass = this.props.checkPass;
        const checkState = this.props.checkState;
        return (
            <div>
                <Button onClick={this.handleCancel}>取消</Button>
                <Button disabled={!checkState} onClick={this.handleCheck}>校验</Button>
                <Button disabled={!checkPass} onClick={this.handleOk}>确定</Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/newformula.jsx